module.exports = __webpack_public_path__ + "static/media/icon-arrow-back.fb78c7df.svg";